import React, { useEffect, useState } from 'react';
import { Row, Col, Form, Select, Button } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { get, post } from '../../config/dataService/dataService';
import { showNotification, MessageType } from '../common/CommonStyle';
import { loginSuccess } from '../../redux/authenticator/authenticationSlice';
import { saveToken } from '../../APIServices/TokenService';
import { get as getRp, saveRP } from '../../APIServices/RolePermissionServices';

const { Option } = Select;

export default function LoginAsAnotherUser({ onCancel, modalopen }) {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [schoolList, setSchoolList] = useState([]);
  const [userList, setUserList] = useState([]);

  const urls = {
    GetAllSchoollist: 'School/GetAllSchool',
    GetUsersBySchoolId: 'Workflow/GetStaffUserBySchoolId',
    SignIn: 'Login',
    RolePermissionUrl: 'RolePermission/RolePermission',
  };

  useEffect(() => {
    if (modalopen) {
      form.resetFields();
      setUserList([]);
      loadSchools();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalopen]);

  const handleCancel = () => {
    form.resetFields();
    setUserList([]);
    onCancel();
  };

  const loadSchools = async () => {
    try {
      const res = await get(urls.GetAllSchoollist);
      setSchoolList(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      showNotification(MessageType.Error, 'Unable to load schools');
    }
  };

  const fetchUsersBySchoolId = async (schoolId) => {
    // const data = {
    //   pageNo: 1,
    //   recordPerPage: 50,
    //   SortBy: '',
    //   IsAscending: false,
    //   Filters: [{ key: 'SchoolId', value: schoolId },{ key: 'IsActive', value: true }],
    //   search: '',
    // };

    // try {
    //   const response = await post(urls.GetUsersBySchoolId, data);
    //   return response?.data || [];
    // } catch (error) {
    //   console.error('Error fetching users:', error);
    //   return [];
    // }
    if (schoolId > 0) {
      try {
        const response = await get(`${urls.GetUsersBySchoolId}?schoolId=${schoolId}`);
        return response?.data || [];
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

  const onSchoolChange = async (schoolId) => {
    form.setFieldsValue({ userId: undefined });
    setUserList([]);

    if (schoolId) {
      try {
        const users = await fetchUsersBySchoolId(schoolId);
        setUserList(users);
      } catch (error) {
        showNotification(MessageType.Error, 'Unable to load users for selected school');
      }
    }
  };

  const onFinish = async (values) => {
    try {
        if(!values.schoolId || !values.userId){
            return;
        }

      const selected = userList.find((u) => String(u.UserId) === String(values.userId));
      if (!selected || !selected.Email) {
        return showNotification(MessageType.Error, 'Selected user has no email to login with');
      }

      const payload = {
        username: selected.Email,
        password: '123456',
      };

      const result = await post(urls.SignIn, payload);

      if (result?.flag === true) {
        dispatch(loginSuccess(result.data));
        saveToken(result.data.token);

        try {
          const res = await get(`${urls.RolePermissionUrl}?id=${encodeURIComponent(result.data.roleIds)}`);
          if (res?.flag === true) {
            saveRP(res.data);
          }
        } catch (rpErr) {
          console.error('Role permission fetch error:', rpErr);
        }

        handleCancel();
        navigate('/admin');
        window.location.reload();
      } else {
        showNotification(MessageType.Error, result?.message || 'Login failed');
      }
    } catch (err) {
      console.error('Login as user failed:', err);
      showNotification(MessageType.Error, 'Login as user failed');
    }
  };

  const onFinishFailed = () => {
    showNotification(MessageType.Error, 'Please fill required fields');
  };

  return (
    <>
      <Form
        form={form}
        name="loginAsUserForm"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row>
          <Col lg={4} md={9} xs={24}>
            <label>
              Select School <span className="required-label" />
            </label>
          </Col>

          <Col lg={20} md={15} xs={24}>
            <Form.Item
              name="schoolId"
              rules={[{ required: true, message: 'School is required' }]}
            >
              <Select
                showSearch
                placeholder="--Please Select--"
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const children = option.props.children;
                  const optionText = typeof children === 'string' ? children : String(children);
                  return optionText.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                }}
                onChange={onSchoolChange}
                allowClear
              >
                {schoolList.map((s) => (
                  <Option key={s.id} value={s.id}>
                    {s.code} | {s.description}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col lg={4} md={9} xs={24}>
            <label>
              Select User <span className="required-label" />
            </label>
          </Col>

          <Col lg={20} md={15} xs={24}>
            <Form.Item
              name="userId"
              rules={[{ required: true, message: 'User is required' }]}
            >
              <Select
                showSearch
                placeholder={form.getFieldValue('schoolId') ? '--Please Select--' : 'Select School First'}
                optionFilterProp="children"
                filterOption={(input, option) => {
                  const label = String(option.children);
                  return label.toLowerCase().includes(input.toLowerCase());
                }}
                allowClear
              >
                {userList.map((u) => (
                  <Option key={u.UserId} value={u.UserId}>
                    {u.FirstName} {u.LastName}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col xs={24} style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <Button type="primary" htmlType="submit">
              Login
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}
